<template>
    <div class="enroll_box" v-loading="loading">
        <div class="enroll_flex">
            <div class="enroll_lefts">
                <div class="enroll_title">
                    做一个有口碑的<span>法律裁判点评网</span>
                </div>
                <div class="enroll_text">
                    全面支持法律服务在线下单，金牌云律师智库在线查询海量合同模板免费下载，各类法律资讯实时推送聚焦社会热点问题，让法律服务更加融入我们的生活全面支持法律服务在线下单，金牌云律师智库在线查询海量合同模板免费下载，各类法律资讯实时推送聚焦社会热点问题，让法律服务更加融入我们的生活
                </div>
            </div>
            <div class="enroll_rights">
                <div class="titles">重置密码</div>
                <div class="type_box">
                    <div class="type_check" :class="{type_check_ac:type_check_ac==1}" @click="type_check_ac=1">
                        <div class="texts">个人会员</div>
                        <div class="borders"></div>
                    </div>
                    <div class="type_check" :class="{type_check_ac:type_check_ac==2}" @click="type_check_ac=2">
                        <div class="texts">企业会员</div>
                        <div class="borders"></div>
                    </div>
                </div>
                <div class="form_box">
                    <div class="input_box">
                        <div class="texts">手机号</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="text" placeholder="请输入手机号" v-model="form.mobile">
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="texts">验证码</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="text" v-model="form.code" placeholder="请输入验证码">
                        </div>
                        <div class="btns" @click="handle_code">{{ code_title }}</div>
                    </div>
                    <div class="input_box">
                        <div class="texts">密码</div>
                        <div class="borders"></div>
                        <div class="inputs">
                            <input type="password" v-model="form.password" placeholder="请输入密码">
                        </div>
                    </div>
                  
                </div>
                <div class="btns_box">
                    <div class="btns" @click="handle_password">确定</div>
                </div>
                <div class="border_box"></div>
                <div class="login_box">
                    <div class="login_fh" @click="handle_fhdl">
                        <img src="../../assets/img/login/fanhui.png" alt="">
                        返回登录
                    </div>
                </div>
            </div>
        </div>        
        <agreement ref="agreement" @handle_end="handle_end"></agreement>
        <password_success ref="password_success"></password_success>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import password_success from '@/components/login/password_success.vue'
export default {
    components: {
        password_success,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            agree_ac:false,
            type_check_ac:1,
            form:{
                mobile:'',
                password:'',
                code:'',
            },
            code_title:'发送验证码',
            code_time:60,
            timer:null,
            code_show:true,
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handle_xy(){
            this.$refs.agreement.handle_open()
        },
        handle_end(){
            this.agree_ac=true
        },
        handle_fhdl(){
            this.$router.push({
                path:'/login'
            })
        },
        handle_code(){
            if(!this.form.mobile){
                alertErr('请输入手机号')
                return
            }
            if(!this.code_show){
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            this.$api("send", {
				mobile:this.form.mobile
			}, "get").then((res) => {
                this.loading = false
                console.log('注册',res)


                this.code_show=false
                this.code_title=this.code_time+'s'
                this.timer=setInterval(() => {
                    if(this.code_time==0){
                        this.code_time=60
                        this.code_show=true
                        this.code_title='重新发送'
                        clearInterval(this.timer)
                    }else{
                        this.code_time=this.code_time-1
                        this.code_title=this.code_time+'s'
                    }
                }, 1000);


                if (res.code == 1) {
                    alertSucc('发送成功')
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_password(){
            if(!this.form.mobile){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            if(!this.form.code){
                alertErr('请输入验证码')
                return
            }
            if(!this.form.password){
                alertErr('请输入密码')
                return
            }
            this.$api("retrieve_password", {
				...this.form,
                log_type:this.type_check_ac
			}, "get").then((res) => {
                this.loading = false
                console.log('忘记密码',res)
                if (res.code == 1) {
                    this.$refs.password_success.handle_open()
                } else {
                    alertErr(res.msg)
                }
            });

        },



    },

}
</script>
<style scoped lang="less">
.enroll_box {
    width: 100%;
    height: 680px;
    background-image: url('../../assets/img/login/login_bg.png');

    background-size:100% 100%;
    .enroll_flex{
        width: 1440px;
        height: 100%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .enroll_lefts{
            .enroll_title{
                font-family: HGJZY, HGJZY;
                font-weight: 400;
                font-size: 48px;
                color: #222222;
                padding-bottom: 63px;
                span{
                    color: #377CFD;
                }

            }
            .enroll_text{
                width: 608px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                line-height: 48px;
            }
        }
        .enroll_rights{
            width: 480px;
            height: 530px;
            background: #FFFFFF;
            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
            border-radius: 12px 12px 12px 12px;
            padding: 32px 40px 25px 40px;
            .titles{
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 20px;
                color: #333333;
            }
            .type_box{
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                .type_check{
                    padding-top: 36px;
                    cursor: pointer;
                    .texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #666666;
                    }
                    .borders{
                        width: 32px;
                        height: 4px;
                        background: #FFFFFF;

                        border-radius: 4px 4px 4px 4px; 
                        margin: auto;
                        margin-top: 10px;
                    }
                    &:hover{
                        .texts{
                            color: #377CFD;
                        }
                        .borders{
                            background: #377CFD;
                        }  
                    }

                }
                .type_check_ac{
                    .texts{
                        color: #377CFD;
                    }
                    .borders{
                        background: #377CFD;
                    }   
                }
            }
            .form_box{
                padding-top: 30px;
                .input_box{
                    width: 400px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;
                    display:flex ;
                    align-items: center;
                    margin-bottom: 20px;
                    .texts{
                        font-weight: 400;
                        font-size: 14px;
                        color: #7D7D7D;
                        // padding: 0 24px;
                        width: 90px;
                        flex-shrink: 0;
                        text-align: center;
                    }
                    .borders{
                        width: 1px;
                        height: 18px;
                        background: #EEEEEE;
                        border-radius: 0px 0px 0px 0px;
                    }
                    .inputs{
                        flex: 1;
                        padding: 0 17px;
                        font-size: 14px;
                        input{
                            width: 100%;
                        }
                    }
                    .btns{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        padding-right:16px;
                    }
                }
            }
            .btns_box{
                padding-top: 40px;
                .btns{
                    width: 400px;
                    height: 44px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    cursor: pointer;
                    line-height: 44px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #FFFFFF;
                    text-align: center;
                }
            }
            .agree_box{
                padding-top: 14px;
                display: flex;
                align-items: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                span{
                    color: #377CFD;
                    cursor: pointer;
                }
            }
            .border_box{
                width: 400px;
                height: 1px;
                background: #E5E5E5;
                border-radius: 0px 0px 0px 0px;
                margin-top: 30px;
            }
            .login_box{
                display: flex;
                align-items: center;
                justify-content: center;
                .login_fh{
                    cursor: pointer;
                    padding-top: 15px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #377CFD;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;



                    span{
                        color: #377CFD;
                        cursor: pointer;
                    }
                    img{
                        width:18px ;
                        height: 12px;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
}
</style>